var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-auth-switcher"},_vm._l((_vm.items),function(item){return _c('h1',{key:item.code,staticClass:"page-auth-switcher__item",class:{ _active: item.code === _vm.content },domProps:{"textContent":_vm._s(item.title)},on:{"click":function($event){return _vm.$emit('switch', item.code)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }